// @vendors
import PropTypes from 'prop-types'

// @commons
const OKModal = require('components/commons/OKModal/OKModal');

// @core
const { formatText } = require('core/i18n').i18n;

// @components
import { ValidationContent } from './components/validationContent';
import { DefaultValidationError } from './components/defaultValidationError';

// @utilities
import { getPrimaryButtonText, getStaticContent } from '../helpers/accountExtendHelper';

import './accountValidationModal.scss'

const buildModalContent = ({titleText, descriptionText}, { isServiceFailed, errorView, defaultView }) => {
  if (titleText || descriptionText) {
    return (
      <ValidationContent
        titleText={titleText}
        descriptionText={descriptionText}
      />
    )
  }

  if (isServiceFailed) {
    return errorView
  }

  return  defaultView
}

const AccountValidationModal = ({
  openModal,
  validationMessage,
  optionSelected,
  onClick,
  onCancel,
  onRetry,
  isServiceFailed,
  children
}) => {
  const { buttonText, ...modalContentData } = validationMessage;
  const { cancelButtonText, ...defaultValidateError } = getStaticContent(optionSelected);
  const primaryButtonText = getPrimaryButtonText({ responseButtonName: buttonText, optionSelected }, isServiceFailed);

  const modalContent = buildModalContent(modalContentData, {
    isServiceFailed,
    defaultView: children || null,
    errorView: <DefaultValidationError {...defaultValidateError} />,
  });

  const primaryButtonAction = isServiceFailed
    ? onRetry
    : onClick

  return (
    openModal && (
      <OKModal
        content={modalContent}
        isOpen={openModal}
        onCloseCallback={() => onCancel(true)}
        size="large"
        footerType="navigation"
        onPrimaryButtonClick={primaryButtonAction}
        onSecondaryButtonClick={() => onCancel(false)}
        primaryButtonText={primaryButtonText}
        secondaryButtonText={formatText(cancelButtonText)}
      />
    )
  );
};

AccountValidationModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  optionSelected: PropTypes.string.isRequired,
  validationMessage: PropTypes.object.isRequired,
  resetAction: PropTypes.func.isRequired,
  isServiceFailed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default AccountValidationModal;
